import type { BoardDto, CreateProjectRequest, ProjectDetailDto, ProjectDto, UpdateProjectRequest } from '@ledokol/contracts'
import { api } from './client'

export async function fetchProjects(
  filters: { department_id?: string; segment_id?: string; employee?: string } = {},
): Promise<ProjectDto[]> {
  const params: Record<string, string> = {}
  if (filters.department_id) params.department_id = filters.department_id
  if (filters.segment_id) params.segment_id = filters.segment_id
  // #3: проекты, где сотрудник лид ИЛИ участник (фильтр на сервере, поверх scope).
  if (filters.employee) params.employee = filters.employee
  const r = await api.get<ProjectDto[]>('/projects', { params })
  return r.data
}

export async function fetchProject(id: string): Promise<ProjectDetailDto> {
  const r = await api.get<ProjectDetailDto>(`/projects/${id}`)
  return r.data
}

export async function fetchBoard(id: string, search?: string): Promise<BoardDto> {
  const r = await api.get<BoardDto>(`/projects/${id}/board`, { params: search ? { search } : {} })
  return r.data
}

/** Soft-delete проекта (admin/director only). project.deletedAt=now(), задачи остаются с FK. */
export async function deleteProject(id: string): Promise<void> {
  await api.delete(`/projects/${id}`)
}

/** PATCH /projects/:id — обновление полей проекта (включая Epic B CRM-поля). */
export async function updateProject(id: string, payload: UpdateProjectRequest): Promise<ProjectDetailDto> {
  const r = await api.patch<ProjectDetailDto>(`/projects/${id}`, payload)
  return r.data
}

/** POST /projects — создать проект (без ТГ). 409 duplicate_name → повторить с allow_duplicate. */
export async function createProject(payload: CreateProjectRequest): Promise<ProjectDetailDto> {
  const r = await api.post<ProjectDetailDto>('/projects', payload)
  return r.data
}
